import './App.css';
import * as React from 'react';

import { Box, ChakraProvider, FormControl, FormHelperText, FormLabel, Heading, HStack, Input, Link, Radio, RadioGroup, Text, Button, Container, Image } from '@chakra-ui/react'

import img1 from './images/golf-img1.jpeg';
import img2 from './images/golf-img2.jpeg';

function calculate() {
  var distance = document.getElementById("distance").value;
  var distance_type = document.querySelectorAll('.chakra-radio__label[data-checked]')[0].textContent

  if (distance_type === 'Rollout') {
    distance = distance * 0.95;
  }

  var ball_speed = distance / 1.75;
  var swing_speed = ball_speed / 1.5;

  document.getElementById('results').innerHTML = 'Your estimated ball speed at impact is ' + parseFloat(ball_speed).toFixed(2) +
    ' mph and your estimated swing and clubhead speed is ' + parseFloat(swing_speed).toFixed(2) + ' mph.'
}

function App() {
  return (
    <ChakraProvider>
      <div className="App">
        <Container>

          <Box py='40px'>
            <Heading as='h1'>Golf - Swing Speed Calculator</Heading>
          </Box>

          <Box p={4} pt='40px' borderTop='1px' borderBottom='1px'>

            <Box w='100%'>
              <Image src={img1} alt='Image of golfer hitting tee shot' />
            </Box>


            <FormControl py={4}>
              <FormLabel htmlFor='distance'>Distance In Yards</FormLabel>
              <Input id='distance' type='number' />
              <FormHelperText align='left'>The distance the ball has travelled, carry or rollout.</FormHelperText>
            </FormControl>
            <FormControl py={4}>
              <FormLabel>Select Distance Format</FormLabel>
              <RadioGroup id='distance_type' defaultValue='Carry' pb={2}>
                <HStack spacing='20px'>
                  <Radio value='Carry'>Carry</Radio>
                  <Radio value='Rollout'>Rollout</Radio>
                </HStack>
              </RadioGroup>
              <FormHelperText align='left'>Carry = distance where ball lands.</FormHelperText>
              <FormHelperText align='left'>Rollout = total distance, where it lands and rolls to.</FormHelperText>
            </FormControl>
            <FormControl py={4}>
              <Button colorScheme='blue' id='calculate' onClick={calculate}>Calculate</Button>
            </FormControl>

            <Heading as='h2' id="results" py={4}></Heading>

          </Box>

          <Box p={4} align='left' pt='60px'>
            <Heading as='h2'>How does it work?</Heading>
            <Text mt={4}>Utilising the information found from <Text as='u'><Link href='https://golftips.golfweek.usatoday.com/estimate-golf-club-speed-2326.html' isExternal color='grey'>
              Golfweek
            </Link></Text> the calculator below calculates an estimate for the speed of a golf swing based on the
              distance the ball travels.</Text>
            <Text mt={4}>
              By knowing how far the ball is approximately travelling, we can calculate swing and clubhead
              speed.
            </Text>
          </Box>

          <Box p={4} align='left'>
            <Heading as='h2'>Why is this useful?</Heading>
            <Text mt={4}>
              Knowing your clubhead speed can help to inform more of your current swing and
              how that relates to the average golfer. Not only this but it can help inform the correct shaft
              flex needed when purchasing clubs as players with higher swing speeds will often notice
              improvements when utilising stiffer shafts.
            </Text>

            <Text mt={4}>
              Some golf balls now even promote different balls aimed at
              players with different swing speeds, such as the <Text as='u'><Link href='https://www.bridgestonegolf.com/en-us/balls/tour-series/tour-brx' isExternal color='grey'>Bridestone Tour B RX</Link></Text> aimed at swing
              speeds lower than 105mph, or the <Text as='u'><Link href='https://www.bridgestonegolf.com/en-us/balls/tour-series/tour-bxs' isExternal color='grey'>Bridgestone Tour B XS</Link></Text> aimed at players with swing
              speed over 105mph.
            </Text>
          </Box>

          <Box p={4} pb='60px' align='left'>
            <Heading as='h2'>How accurate is it?</Heading>
            <Text mt={4}>
              The calculator provides only an estimate of the swing and clubhead speed as there
              are many variables to consider that can effect the results generated.
            </Text>
            <Text mt={4}>
              The results obtained also depend on how accurate the distance information input is. Exaggerated
              distances inserted could result in an inaccurate calculation which would not reflect true swing speed.
            </Text>
            <Text mt={4}>
              As mentioned previously, the calculator aims to provide a rough estimation of the swing speed based of distance provided.
              If you require exact and precise numbers then a proper golf fitting with a professional who will likely
              have access to computerised equipment, such as a TrackMan of GCQuad, may offer you with a better solution and results.
            </Text>
          </Box>

          <Box w='100%'>
            <Image src={img2} alt='Image of golfer hitting tee shot' />
          </Box>

        </Container>

        <Container>
          <Box py={4} pb="60px">
            <Heading as='h2' my={4}>Privacy Policy</Heading>

            <Text>Golf Swing Speed Calculator Privacy Policy</Text>

            <Text>This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from https://golf-swing-speed-calculator.netlify.app/ (the “Site”).</Text>

            <Heading size='18px' mt={5} mb={3}>PERSONAL INFORMATION WE COLLECT</Heading>

            <Text>When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the Site, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site. We refer to this automatically-collected information as “Device Information.”</Text>

            <Text>We collect Device Information using the following technologies:</Text>

            <Text>- “Cookies” are data files that are placed on your device or computer and often include an anonymous unique identifier. For more information about cookies, and how to disable cookies, visit http://www.allaboutcookies.org.</Text>
            <Text>- “Log files” track actions occurring on the Site, and collect data including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps.</Text>
            <Text>- “Web beacons,” “tags,” and “pixels” are electronic files used to record information about how you browse the Site.</Text>

            <Text>Additionally when you make a purchase or attempt to make a purchase through the Site, we collect certain information from you, including your name, billing address, shipping address, payment information (including credit card numbers), email address, and phone number.  We refer to this information as “Order Information.”</Text>

            <Text>When we talk about “Personal Information” in this Privacy Policy, we are talking both about Device Information and Order Information.</Text>

            <Heading size='18px' mt={5} mb={3}>HOW DO WE USE YOUR PERSONAL INFORMATION?</Heading>

            <Text>We use the Order Information that we collect generally to fulfill any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations).  Additionally, we use this Order Information to:</Text>
            <Text>Communicate with you;</Text>
            <Text>Screen our orders for potential risk or fraud; and</Text>
            <Text>When in line with the preferences you have shared with us, provide you with information or advertising relating to our products or services.</Text>

            <Text>We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address), and more generally to improve and optimize our Site (for example, by generating analytics about how our customers browse and interact with the Site, and to assess the success of our marketing and advertising campaigns).</Text>

            <Heading size='18px' mt={5} mb={3}>SHARING YOUR PERSONAL INFORMATION</Heading>

            <Text>We share your Personal Information with third parties to help us use your Personal Information, as described above.  For example, we use Shopify to power our online store--you can read more about how Shopify uses your Personal Information here:  https://www.shopify.com/legal/privacy.  We also use Google Analytics to help us understand how our customers use the Site--you can read more about how Google uses your Personal Information here:  https://www.google.com/intl/en/policies/privacy/.  You can also opt-out of Google Analytics here:  https://tools.google.com/dlpage/gaoptout.</Text>

            <Text>Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.</Text>

            <Heading size='18px' mt={5} mb={3}>BEHAVIOURAL ADVERTISING</Heading>
            <Text>As described above, we use your Personal Information to provide you with targeted advertisements or marketing communications we believe may be of interest to you.  For more information about how targeted advertising works, you can visit the Network Advertising Initiative’s (“NAI”) educational page at http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.</Text>

            <Text>You can opt out of targeted advertising by:</Text>
            <Text>GOOGLE - https://www.google.com/settings/ads/anonymous</Text>

            <Text>Additionally, you can opt out of some of these services by visiting the Digital Advertising Alliance’s opt-out portal at:  http://optout.aboutads.info/.</Text>

            <Heading size='18px' mt={5} mb={3}>DO NOT TRACK</Heading>
            <Text>Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.</Text>

            <Heading size='18px' mt={5} mb={3}>YOUR RIGHTS</Heading>
            <Text>If you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below.</Text>
            <Text>Additionally, if you are a European resident we note that we are processing your information in order to fulfill contracts we might have with you (for example if you make an order through the Site), or otherwise to pursue our legitimate business interests listed above.  Additionally, please note that your information will be transferred outside of Europe, including to Canada and the United States.</Text>


            <Heading size='18px' mt={5} mb={3}>DATA RETENTION</Heading>
            <Text>When you place an order through the Site, we will maintain your Order Information for our records unless and until you ask us to delete this information.</Text>

            <Heading size='18px' mt={5} mb={3}>CHANGES</Heading>
            <Text>We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.</Text>
            
          </Box>
        </Container>


      </div>
    </ChakraProvider>
  );
}

export default App;
